<template>
  <div>
    <common-dialog
      class="forum-dialog"
      center
      @close="handlerClose"
      :close-on-click-modal="false"
      title="新建讨论"
      :visible.sync="dialogVisible"
      width="70%">
      <div class="detail-panel">
        <div class="panel-left">
          <div class="member-search">
            <i class="search-input-icon icon-sousuo iconfont"></i>
            <input type="text" class="search-input" v-model="keyword">
            <i class="clear-input-icon icon-tianjia iconfont" @click="clearSearchCondition"></i>
          </div>
          <div class="member-list">
            <div v-for="(item,index) of discuss.users" :key="item.userId">
              <el-row>
                <div class="member-list-item">
                  <el-checkbox v-model="item.checked" class="item-checkbox" :key="item.userId">
                    <span class="member-list-avatar"
                          :style="`background-image: url(${avatarPre}/${item.avatar}`"></span>
                    <span class="member-list-text">
                       <span class="member-list-name">{{ item.name }}</span>
                        <span class="member-list-userId">手机号：{{ item.userId }}</span>
                    </span>
                  </el-checkbox>
                </div>
              </el-row>
            </div>

          </div>
          <div class="member-list-invite">
            <el-row :gutter="20">
              <div v-for="(item,index) of members" :key="index">
                <el-col :span="memberSpan">
                     <span class="member-item">
                        <div class="remove-item-btn icon-tianjia iconfont" @click="handleRemoveMember(item)"></div>
                        <div class="member-item-up"
                             :style="`background-image: url(${avatarPre}/${item.avatar}`"></div>
                        <div class="member-item-down">
                          <div class="user-name" :title="item.name">{{ item.name }}</div>
                        </div>
                    </span>
                </el-col>
              </div>
            </el-row>
          </div>
        </div>
        <div class="panel-right">
          <div class="panel-right-up">
            <div class="discuss-title">
              <el-input v-model="discuss.title" placeholder="请输入讨论标题"></el-input>
            </div>
            <div class="discuss-content">
              <el-input
                type="textarea"
                placeholder="请输入讨论内容"
                v-model="discuss.content">
              </el-input>
            </div>
          </div>

          <div class="panel-right-down">
            <el-upload
              class="upload-btn"
              action
              multiple
              :show-file-list="false"
              fullscreen="true"
              :http-request="forumUpload"
              :before-upload='handleBeforeUpload'>
              <el-button size="small" type="primary">点击上传附件</el-button>
            </el-upload>

            <div class="attachment-list">
              <div style="height: 100%;overflow-y: hidden;text-align: center">
                <el-table :data="discuss.attachments" border size="small">
                  <el-table-column align="center" prop="attachmentOriginalName" label="原文件名称"></el-table-column>
                  <el-table-column align="center" prop="attachmentName" label="文件别名">
                    <template slot-scope="scope">
                      <el-input :placeholder="'输入别名'" class="text-input"
                                v-model="scope.row.attachmentName"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="" label="操作" width="50">
                    <template slot-scope="scope">
                      <!--移除附件-->
                      <el-button style="border:0px !important;" type="text" size="small" class="el-icon-close"
                                 @click="beforeRemove(scope.row, scope.$index)"></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="info" size="small">取 消</el-button>
        <el-button type="primary" @click="handleSaveDiscuss" size="small">确 定</el-button>
      </span>
    </common-dialog>
    <!--加载动画-->
    <animation :loadingDataVisible="isLoading"></animation>

  </div>
</template>

<script>
import {generateStandardSpan} from "@/utils/acquireStandardSpan";
import http from '@/utils/axios'
import cookie from "@/utils/cookie";
import {ATTA_UPLOAD_COMPONENT_TYPE_STR} from '@/constants/constants';
import {Message} from "element-ui";
import animation from '@/components/loading/animation'

export default {
  name: "ForumInvite",
  components: {animation},
  data() {
    return {
      that: this,
      keyword: null,
      searchTimeout: null,
      //灵敏度
      attachmentSensitive: 250,
      attachmentSpan: 6,
      memberSensitive: 80,
      memberSpan: 6,
      avatarPre: window.config.avatar.baseUrl,
      dialogVisible: false,
      discuss: {
        users: [],
        attachments: [],
      },
      discussAttachmentCode: '001-042',
      //被邀请的成员信息
      members: [],
      //真实附件的信息
      attachments: [],
      attaFileSuf: ATTA_UPLOAD_COMPONENT_TYPE_STR,
      isLoading: false,
      //准备的颜色的数组
      attachmentColors: {
        'ppt': "#fd585e",
        'doc': "#2a83eb",
        'docx': "#2a83eb",
        'xls': "#16b881",
        'xlsx': "#16b881",
        'pdf': "#ff734c",
        "unKnown": "#5c5b5b",
      },
      fileIconType: {
        'ppt': 'icon-file-ppt-fill',
        'xls': 'icon-file-excel-fill',
        'xlsx': 'icon-file-excel-fill',
        'doc': 'icon-file-word-fill',
        'docx': 'icon-file-word-fill',
        'pdf': 'icon-file-pdf-fill',
        "unKnown": "icon-bg-unknownfile",
      },

    }

  },

  filters: {
    //取截单元,单位
    fileSizeUnit: (arg) => {
      if (parseFloat(arg) / (1024 * 1024) > 1) {
        return (parseFloat(arg) / (1024 * 1024)).toFixed(2) + 'M'
      } else if (parseFloat(arg) / (1024) > 1) {
        return (parseFloat(arg) / (1024)).toFixed(2) + 'K'
      } else {
        return arg + 'B';
      }
    },
    //设置图标的颜色
    fileColor: function (arg, this_) {
      let type = arg.attachmentOriginalName.substring(arg.attachmentOriginalName.lastIndexOf('.') + 1)
      return ("color:" + this_.attachmentColors[type])

    },

    //设置类图标
    fileIcon: function (arg, this_) {
      let type = arg.attachmentOriginalName.substring(arg.attachmentOriginalName.lastIndexOf('.') + 1)
      return (this_.fileIconType[type] + ' iconfont')
    }
  },

  watch: {
    dialogVisible(newVal) {
      if (newVal) {
        //查询用户列表数据
        this.initData();
      }
    },

    keyword(newVal) {
      this.searchConditionChange()
    },

    'discuss.users': {
      deep: true,
      handler(newVal) {
        for (let item of newVal) {
          if (item.checked) {
            //查询是否有这个数据
            let data = this.members.find(ev => {
              return ev.userId === item.userId
            })
            if (this.members.length === 0 || !data) {
              this.members.push(item)
            }
          } else {
            //取消选中将选中的数据移除
            for (let i = 0; i < this.members.length; i++) {
              let member = this.members[i]
              if (member.userId === item.userId) {
                this.members.splice(i, 1)
              }
            }
          }
        }
      },
    }
  },

  mounted() {
    this.initPage()

  },

  //销毁时销毁监听器
  beforeDestroy() {
    window.removeEventListener("resize", this.timeOutChange)
  },
  methods: {

    beforeRemove(row,index){
      this.attachments.splice(index,1)
      this.discuss.attachments.splice(index,1)
    },

    handleSaveDiscuss() {
      let that = this

      if (!this.discuss.title){
        this.$message({
          type: 'error',
          message: '标题不能为空！'
        });
        return
      }

      if (!this.discuss.content){
        this.$message({
          type: 'error',
          message: '内容不能为空！'
        });
        return
      }
      this.$confirm('保存此病例讨论?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //保存讨论
        that.saveDiscussInfo()
      }).catch(() => {});


    },

    saveDiscussInfo() {
      let that = this
      // 使用form表单的数据格式
      const paramsData = new FormData()
      this.discuss.users = JSON.parse(JSON.stringify(this.members))
      // 将上传文件数组依次添加到参数paramsData中
      this.attachments.forEach((it, index) => {
        paramsData.append(`file`, it.file)
      });
      if (this.attachments.length === 0){
        paramsData.append(`file`, null)
      }
      let jsonData = {
        token: cookie.getCookie("token"),
        data: {
          attachment: this.discuss.attachments,
          cd: this.discussAttachmentCode,
          discuss: this.discuss
        }
      }
      Message.info("数据导入可能需要几分钟,请耐心等待")
      //将表单数据添加到参数paramsData中,需要将参数转化成Blob后端才能识别到文件
      paramsData.append('data', new Blob([JSON.stringify(jsonData)], {type: "application/json"}));
      // 表单数据和文件一起上传,调用后端接口
      this.isLoading = true
      http.post(window.config.api.baseUrl + '/eims-api/discuss/create', paramsData).then(value => {
        if (value.data.code === '00000') {
          Message.success("病例讨论已提交审核")
          that.discuss = that.$options.data().discuss
          that.members = that.$options.data().members
          that.attachments = that.$options.data().attachments

        }
      }).finally(() => {
        that.isLoading = false;
        that.dialogVisible = false;
      })
    },


    handleRemoveMember(item) {
      //移除members中的数据
      this.members.splice(this.members.indexOf(item), 1)

      //移除users中的选中状态
      for (let user of this.discuss.users) {
        if (user.userId === item.userId) {
          user.checked = false
        }
      }
    },

    forumUpload(file, fileList) {
      //将附件的信息添加到讨论中
      this.discuss.attachments.push({
        attachmentOriginalName: file.file.name
      })
      this.attachments.push(file)
    },

    handleBeforeUpload(file) {
      let testMsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (!this.attaFileSuf.includes(testMsg)) {
        this.$message({
          message: '上传附件类型不合法！',
          type: 'warning',
          showClose: true
        })
        return false
      } else {
        return true
      }
    },

    clearSearchCondition() {
      this.keyword = null
    },

    searchConditionChange() {
      //防抖节流
      let that = this
      if (this.searchTimeout != null) {
        clearTimeout(this.searchTimeout)
        this.searchTimeout = null
      }
      this.searchTimeout = setTimeout(() => {
        that.initData()
      }, 200)

    },

    initData() {
      let that = this
      this.isLoading = true
      http.post(window.config.api.baseUrl + '/eims-api/discuss/member/query', {
        token: cookie.getCookie("token"),
        data: {
          keyword: that.keyword
        }
      }).then((response) => {
        let data = response.data.data;
        that.discuss.users = []
        //设置数据的选中状态
        for (let item of data.members) {
          let data = that.members.find(member => {
            return member.userId === item.userId
          })
          //添加数据的选中状态
          if (data) {
            item.checked = true
          }
          that.discuss.users.push(item)
        }


      }).finally(() => {
        that.isLoading = false;
      });

    },

    initPage() {
      window.addEventListener("resize", this.timeOutChange, false);
    },

    handlerClose() {
      this.dialogVisible = false

    },

    changeDialogStatus(status) {
      this.dialogVisible = status
      if (this.dialogVisible) {
        let that = this
        setTimeout(() => {
          that.windowSizeChange()
        }, 10)
      }

    },

    timeOutChange() {
      let that = this
      if (this.spanTimeout !== null) {
        clearTimeout(this.spanTimeout)
        this.spanTimeout = null
      }

      this.spanTimeout = setTimeout(() => {
        that.windowSizeChange()
      }, 10)
    },

    //窗口发生变化
    windowSizeChange() {
      if (this.dialogVisible){
        let memberPanel = document.getElementsByClassName("member-list-invite")[0]
        this.memberSpan = generateStandardSpan(memberPanel.offsetWidth, this.memberSensitive)

        let attachmentPanel = document.getElementsByClassName("panel-right-down")[0]
        this.attachmentSpan = generateStandardSpan(attachmentPanel.offsetWidth, this.attachmentSensitive)
      }
    },
  }
}
</script>

<style scoped>

.detail-panel {
  width: 100%;
  height: 60vh;
}

.panel-left {
  float: left;
  width: calc(40% - 10px);
  height: 100%;
}

.panel-right {
  height: 100%;
  width: calc(60% - 10px);
  float: right;
}

.panel-right-up {
  height: calc(50% - 10px);
  overflow-y: auto;
}

.discuss-title {
  margin: 10px;
}

.discuss-content {
  margin: 10px;
}

.discuss-content >>> .el-textarea__inner {
  height: 20vh;
}

.member-list {
  margin: 10px;
  width: 100%;
  height: calc(50% - 10px);
  overflow-y: auto;
}

.member-list-item {
  width: 100%;
  height: 60px;

}

.member-list-item:before {
  content: '';
  width: calc(100% - 78px);
  height: 59px;
  border-bottom: #e3e3e3 1px solid;
  position: absolute;
  left: 78px;
}

.member-list-item:hover{
  cursor: pointer;
  background-color: #dadada;
}

/*   >>>深度选择器*/
.item-checkbox >>> .el-checkbox__inner {
  margin: 23px 0;
}

/*   >>>深度选择器*/
.item-checkbox >>> .el-checkbox__input {
  vertical-align: top;
}

.member-list-avatar {
  border-radius: 2px;
  border: 2px solid rgba(201, 200, 200, 0.33);
  display: inline-block;
  margin: 10px 0;
  width: 40px;
  height: 40px;
  background-size: cover;
}

.member-list-name {
  font-size: 16px;
  display: block;
}

.member-list-userId {
  font-size: 14px;
  display: block;
}

.member-list-text {
  padding: 10px;
  vertical-align: top;
  display: inline-block;
  width: 100%;
  height: 60px;
}

.member-list-invite {
  margin: 10px;
  border-radius: 10px;
  padding: 5px 10px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  height: calc(50% - 10px);
}


.member-item {
  position: relative;
  display: inline-block;
}

.member-item-up {
  border-radius: 5px;
  border: 3px solid #e2dddd;
  background-size: cover;
  width: 50px;
  height: 50px;
  margin: 5px auto;
}

.member-item-down {
  font-size: 14px;
  width: 50px;
  margin: 0 auto;
}

.user-name {
  line-height: 20px;
  text-align: center;
  width: 100%;
  /*将元素设置行内块元素，否则下面的设置将会无效*/
  display: inline-block;
  /*将超出的文本隐藏*/
  overflow: hidden;
  /*设置文本超出span长度之需要设置为不换行*/
  white-space: nowrap;
  /*将溢出的文本使用...显示*/
  text-overflow: ellipsis;
}

.remove-item-btn {
  position: relative;
  top: 15px;
  right: -43px;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: #6e6e6e55;
  border-radius: 100%;
}

.icon-tianjia {
  cursor: pointer;
  color: #FFFFFF;
  transform: rotate(45deg);
}

.member-search {
  position: relative;
}

.search-input {
  width: calc(100% - 5px);
  height: 35px;
  margin: 2.5px;
  padding: 2px 30px;
  border: 1px solid #afafaf;
  border-radius: 5px;
}

.search-input:focus {
  outline: none;
}

.search-input-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  z-index: 999;
  position: absolute;
  top: 10px;
  left: 10px;
}

.clear-input-icon {
  line-height: 22px;
  color: #b2b2b2;
  display: inline-block;
  width: 20px;
  height: 20px;
  z-index: 999;
  position: absolute;
  top: 10px;
  right: 10px;
}

.panel-right-down {
  overflow-y: auto;
  height: 50%;
  padding: 10px;
}

.upload-btn {
  display: inline-block;
  width: 100px;
  height: 40px;
}

.forum-dialog >>> .el-dialog__header {
  background: url(/static/images/bgimage.png) no-repeat;
  background-color: #fa907a85;
  background-size: 100%;
  text-align: center;
  font-size: 17px;
  font-weight: bold;
}

/deep/ .el-dialog--center .el-dialog__body {

}

</style>



// WEBPACK FOOTER //
// src/components/detail/ForumDetail.vue